import React, { Component } from "react";
import { getTabs } from "../../../services/formService";
import CustomLoader from "../../common/Loader";
import FormViewer from "../FormViewer";

class TabViewer extends Component {
  state = {
    Widget_ID: this.props.Widget_ID,
    Tabs: [{ Tab_ID: -1, Tab_Name: "", Tab_Form_ID: "" }],
    selected_tab: 0,
    loading: true,
    selectedInst: this.props.selectedInst,
    triggerRender: this.props.triggerRender ? this.props.triggerRender : false,
    PrimaryKey: this.props.PrimaryKey,
    PK_Name: this.props.PK_Name ? this.props.PK_Name : null,
    Question_Number: this.props.Question_Number ? this.props.Question_Number : 0,
    SurveyMode: this.props.SurveyMode,
    Project_ID: this.props.Project_ID ? this.props.Project_ID : 0,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const { data: Tabs } = await getTabs(this.state.Widget_ID);
    this.setState({ Tabs });
    this.setState({
      ActiveForm: 
      < FormViewer
        key={this.state.triggerRender}
        PrimaryKey={this.state.PrimaryKey}
        PK_Name={this.state.PK_Name}
        Form_ID={Tabs[0].Tab_Form_ID}
        selectedInst={this.state.selectedInst}
        Responses={this.props.Responses}
        Project_ID={this.state.Project_ID}
        isTab={true}
      />
    })
    this.setState({ loading: false });
  }

  handleTab = (idx) => {
    let tab = this.state.Tabs[idx]
    this.setState({
      ActiveForm: 
      < FormViewer
        key={this.state.selected_tab}
        PrimaryKey={this.state.PrimaryKey}
        PK_Name={this.state.PK_Name}
        Form_ID={tab.Tab_Form_ID}
        selectedInst={this.state.selectedInst}
        Responses={this.props.Responses}
        Project_ID={this.state.Project_ID}
        isTab={true}
      />
    })
    this.setState({ selected_tab: idx });
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }
    const { Tabs, Question_Number, SurveyMode } = this.state;
    return (
      <div className="card mb-4">
        <div className="card-header">
          <ul className="nav nav-tabs card-header-pills" role="tablist">
            {Tabs.map((tab, idx) => {
              return (
                <li className="nav-item">
                  <a
                    href={"#" + tab.Tab_Name}
                    className={
                      "nav-link" +
                      (idx === this.state.selected_tab ? " active" : "")
                    }
                    key={"tab" + tab.Tab_ID}
                    data-toggle="tab"
                    role="tab"
                    aria-controls={tab.Tab_Name}
                    onClick={() => this.handleTab(idx)}
                  >
                    {tab.Tab_Name}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="card-body">
          <div className="tab-content">
            {this.state.ActiveForm}
          </div>
        </div>
      </div>
    );
  }
}

export default TabViewer;
